import { render, staticRenderFns } from "./Associazioni.vue?vue&type=template&id=4181d493&scoped=true&"
import script from "./Associazioni.vue?vue&type=script&lang=js&"
export * from "./Associazioni.vue?vue&type=script&lang=js&"
import style0 from "./Associazioni.vue?vue&type=style&index=0&id=4181d493&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4181d493",
  null
  
)

export default component.exports